export { default } from './QuotesView';



// WEBPACK FOOTER //
// ./src/components/views/QuotesView/index.js